// Entry screen: pointer-driven split, then the chosen half expands into its loading screen.
(function () {
  const split = document.getElementById('split');
  const status = document.getElementById('loader-status');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;

  // --- Pointer-driven split: the half under the pointer widens, smoothly ---
  let target = 50, current = 50, px = 0.5, py = 0.5, mx = 0, my = 0, leaving = false;

  if (finePointer && !reduce) {
    addEventListener('pointermove', (e) => {
      px = e.clientX / innerWidth;
      py = e.clientY / innerHeight;
      target = 50 + (0.5 - px) * 18;          // 59% .. 41%
    }, { passive: true });
    document.documentElement.addEventListener('pointerleave', () => { target = 50; px = py = 0.5; });
    // keyboard: the focused side widens the same way the pointed-at side does
    split.addEventListener('focusin', (e) => {
      const side = e.target.closest('.side');
      if (!side) return;
      px = side.dataset.side === 'justbuy' ? 0.1 : 0.9; py = 0.5;
      target = 50 + (0.5 - px) * 18;
    });

    (function frame() {
      if (!leaving) {
        current += (target - current) * 0.075;
        mx += ((px - 0.5) * 2 - mx) * 0.06;
        my += ((py - 0.5) * 2 - my) * 0.06;
        split.style.setProperty('--l', current.toFixed(3));
        split.style.setProperty('--mx', mx.toFixed(4));
        split.style.setProperty('--my', my.toFixed(4));
      }
      requestAnimationFrame(frame);
    })();
  }

  // --- Live clock on the Just Buy half's REC tag ---
  const clock = document.querySelector('[data-clock]');
  if (clock) {
    const two = (n) => String(n).padStart(2, '0');
    const tickClock = () => { const d = new Date(); clock.textContent = two(d.getHours()) + ':' + two(d.getMinutes()) + ':' + two(d.getSeconds()); };
    tickClock(); setInterval(tickClock, 1000);
  }

  // --- Choosing a side ---
  split.addEventListener('click', (e) => {
    const link = e.target.closest('a.side');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    choose(link);
  });

  function choose(link) {
    if (leaving) return;
    leaving = true;
    const side = link.dataset.side;
    const href = link.getAttribute('href');
    const loader = document.getElementById('loader-' + side);
    const bar = loader.querySelector('.loader__bar');
    const name = side === 'justbuy' ? 'Just Buy Online' : 'Billiard Accessories Achkar';

    split.classList.add('is-leaving');
    split.style.setProperty('--l', side === 'justbuy' ? 100 : 0);
    document.querySelector('meta[name=theme-color]').content = side === 'justbuy' ? '#021832' : '#15306B';

    const setProgress = (p) => bar.style.setProperty('--p', Math.min(1, p).toFixed(3));
    const loaded = window.AG_CATALOG ? window.AG_CATALOG.warm(side, href, setProgress) : preload(link.dataset.data, href, setProgress);

    const expandTime = reduce ? 0 : 640;
    const minLoaderTime = reduce ? 300 : 1750;

    setTimeout(() => {
      loader.hidden = false;
      // restart animations if the loader was shown before (back button)
      loader.classList.remove('is-playing'); void loader.offsetWidth; loader.classList.add('is-playing');
      status.textContent = window.I18N ? window.I18N.t('entry.opening', { name: name }) : 'Opening ' + name;

      const minWait = new Promise((r) => setTimeout(r, minLoaderTime));
      const maxWait = new Promise((r) => setTimeout(r, 6000));
      Promise.race([Promise.all([minWait, loaded]), maxWait]).then(() => {
        setProgress(1);
        try { sessionStorage.setItem('ag-arrived', side); } catch (_) {}
        setTimeout(() => { location.href = href; }, reduce ? 0 : 260);
      });
    }, expandTime);
  }

  // Warm the cache: the store page, its catalogue and the first product photos.
  function preload(dataSrc, pageHref, onProgress) {
    // the store page itself; its styles and scripts carry version tags, so the page asks for the right ones
    [pageHref].forEach((u) => {
      const l = document.createElement('link'); l.rel = 'prefetch'; l.href = u; document.head.appendChild(l);
    });
    return new Promise((resolve) => {
      const s = document.createElement('script');
      s.src = dataSrc;
      s.onerror = () => resolve();
      s.onload = () => {
        const list = (window.SITE && window.SITE.products) || [];
        const urls = list.slice(0, 12).map((p) => 'assets/img/t/' + String(p.img[0]).padStart(3, '0') + '.webp');
        let done = 0;
        if (!urls.length) return resolve();
        urls.forEach((u) => {
          const img = new Image();
          img.onload = img.onerror = () => {
            done++; onProgress(0.15 + 0.85 * (done / urls.length));
            if (done === urls.length) resolve();
          };
          img.src = u;
        });
      };
      document.head.appendChild(s);
      onProgress(0.08);
    });
  }

  // Coming back with the Back button: undo the leaving state.
  addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    leaving = false;
    split.classList.remove('is-leaving');
    split.style.setProperty('--l', current = target = 50);
    document.querySelectorAll('.loader').forEach((l) => { l.hidden = true; l.classList.remove('is-playing'); });
    document.querySelector('meta[name=theme-color]').content = '#021832';
    status.textContent = '';
  });
})();
